var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"leave"},[_c('title-bar',{attrs:{"title":"Niet gevonden","left":{ text: 'Terug', path: '/' }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }